import { Injectable } from '@angular/core';
import { BaseServiceWithFilter } from './base.service';
import { MotdMessage } from '@cl/shared/models/motd-messages/motd-message.model';
import { HttpClient } from '@angular/common/http';
import { CommandResult } from '@cl/shared/models';
import { lastValueFrom } from 'rxjs';
import { MotdMessageFilter } from '@cl/shared/models/motd-messages/motd-message-filter.model';

@Injectable({
    providedIn: 'root',
})
export class MotdMessagesService extends BaseServiceWithFilter<MotdMessage, MotdMessageFilter> {
    constructor(protected httpClient: HttpClient) {
        super(httpClient, '/api/v1/motd/');
    }

    async getAllActiveHeaderMessages(): Promise<CommandResult<MotdMessage[]>> {
        return await lastValueFrom(this.httpClient.get<CommandResult<MotdMessage[]>>(`${this.baseApiUrl}active-header`));
    }

    async getAllActiveModalMessages(): Promise<CommandResult<MotdMessage[]>> {
        return await lastValueFrom(this.httpClient.get<CommandResult<MotdMessage[]>>(`${this.baseApiUrl}active-modal`));
    }

    async setMessageDismissed(motdMessage: MotdMessage): Promise<CommandResult<void>> {
        return await lastValueFrom(this.httpClient.put<CommandResult<void>>(`${this.baseApiUrl}set-dismissed/${motdMessage.id}`, null));
    }

    async setMessageSeen(motdMessage: MotdMessage): Promise<CommandResult<void>> {
        return await lastValueFrom(this.httpClient.put<CommandResult<void>>(`${this.baseApiUrl}set-seen/${motdMessage.id}`, null));
    }
}
